import create from "zustand";

export type Flags = {
  [key: string]: boolean;
};

interface FeatureFlagsStore {
  cloudNumbersFlags: Flags;
  setCloudNumbersFlags: (flags: Flags) => void;
}

export const useFeatureFlagsStore = create<FeatureFlagsStore>((set) => ({
  cloudNumbersFlags: {},
  setCloudNumbersFlags: (flags) => set({ cloudNumbersFlags: flags }),
}));
